module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image08-f7043408d07a6d19f3a6a253a419fca4.png";